import { HHButton } from '@hinge-health/react-component-library';
import { generatePath, Link } from 'react-router-dom';
import { newContractLabel } from '../../constants/strings/header-labels';
import { useBillingWriteAccess } from '../../hooks/use-billing-write-access';

export const NewContractButton = ({
  label = newContractLabel,
  variant = 'outlined',
  route,
  sx,
}: {
  label?: string;
  route: string;
  variant?: 'outlined' | 'text' | 'contained';
  sx?: Record<string, unknown>;
}): JSX.Element | null => {
  if (!useBillingWriteAccess()) return null;

  return (
    <Link color="inherit" to={generatePath(route)}>
      <HHButton
        data-testid="new-contract-button"
        hhVariant="variant-bypass"
        variant={variant}
        size="medium"
        color="primary"
        sx={sx}
      >
        {label}
      </HHButton>
    </Link>
  );
};
